import React from 'react';
import { Tabs, TabsHeader, TabsBody, Tab, TabPanel } from '@material-tailwind/react';
import Link from 'next/link';

const PythonServicesOffered = () => {
    const data = [
        {
            label: 'Python Web Application Development',
            value: 'CustomAI',
            title: 'Python Web Application Development',
            desc: `We build custom web applications using Django and Flask, built to handle complex 
            workflows, large datasets, and real-time interactions. Whether it's a multi-tenant 
            SaaS platform, an enterprise-grade portal, or a custom automation system, we 
            architect solutions that prioritize performance, adaptability, and maintainability.`,

            list: [
                'Custom-built web applications for enterprises & startups',
                'Secure & scalable architecture using Django & Flask',
                'Seamless third-party integrations for enhanced functionality',
            ],
        },
        {
            label: 'Python API development and Integration',
            value: 'machinelearning',
            title: 'Python API development and Integration',
            desc: `APIs are the backbone of modern applications, enabling smooth communication 
            between systems. With expertise in RESTful and GraphQL APIs, we create solutions
            that optimize data flow, enhance system interoperability, and improve application 
            efficiency.`,

            list: [
                'Custom API development for seamless system connectivity',
                'Secure & scalable integrations with third-party services',
                'Optimized API performance for high efficiency',
            ],
        },
        {
            label: 'Python Migration Services',
            value: 'dataanalysis',
            title: 'Python Migration Services',
            desc: `Moving to a Python-based framework unlocks better performance, lower 
            maintenance overhead, and a future-ready tech stack. We help businesses 
            modernize their applications without downtime or disruptions.`,

            list: [
                'Seamless legacy-to-Python migration with minimal downtime',
                'Code refactoring & database modernization for performance',
                'Cloud adoption & scalability enhancements',
            ],
        },
        {
            label: 'Data Science and Analytics',
            value: 'predictiveanalytics',
            title: 'Data Science and Analytics',
            desc: `Unlock the power of big data, predictive analytics, and AI-driven insights with Python. We specialize in building Python-powered data processing pipelines, predictive 
            analytics models, and AI-driven dashboards that help businesses make informed 
            decisions.`,

            list: [
                'Data processing & predictive analytics with Pandas & NumPy',
                'AI-powered business intelligence for deeper insights',
                'Custom machine learning models for automation',
            ],
        },
        {
            label: 'Machine learning & AI solutions',
            value: 'naturallanguage',
            title: 'Machine learning & AI solutions',
            desc: `Data alone doesn't drive business growth—machine learning turns raw information 
            into meaningful insights. Our expertise in TensorFlow, PyTorch, and Scikit-learn 
            enables tailored solutions that align with your goals and continuously improve with 
            use.`,

            list: [
                'Chatbots & AI-powered automation for business efficiency',
                'Predictive analytics & intelligent recommendations',
                'Powerful AI integration with existing systems',
            ],
        },
        {
            label: 'IoT Application Development',
            value: 'computervision',
            title: 'IoT Application Development',
            desc: `From industrial automation to consumer smart devices, we build IoT platforms that 
            turn data into action. Leverage Python-based IoT solutions that collect and analyze 
            sensor data, enable remote control, and integrate with cloud services for better 
            scalability.`,

            list: [
                'Custom IoT solutions for connected devices',
                'Edge computing & real-time data processing',
                'Integration with cloud infrastructure',
            ],
        },
        {
            label: 'Cloud-based Python Development',
            value: 'roboticprocess',
            title: 'Cloud-based Python Development',
            desc: `We build and deploy Python applications on AWS, Azure, and Google Cloud, 
            ensuring optimized resource management and fast execution. Whether you need a 
            microservices-based architecture, or a backend for a high-traffic application, we help 
            you leverage the cloud to its fullest.`,

            list: [
                'Serverless & microservices-based architecture',
                'Cloud deployment for cost efficiency & scalability',
                'Optimized for high traffic & data-intensive applications',
            ],
        },
        {
            label: 'Python Mobile App Development',
            value: 'generativeai',
            title: 'Python Mobile App Development',
            desc: `Develop high-performance, cross-platform mobile apps with Python frameworks like 
            Kivy and BeeWare, enabling a single codebase to work across multiple platforms. 
            This simplifies development while ensuring native-like performance on iOS and 
            Android.`,

            list: [
                'AI-driven chatbots & real-time applications',
                'Cross-platform development for iOS & Android',
                'Secure backend & database integration',
            ],
        },
        {
            label: 'Python CMS Development',
            value: 'aiconsultation',
            title: 'Python CMS Development',
            desc: `A content management system (CMS) should be more than just a publishing tool—it 
            should automate workflows, enhance collaboration, and provide deep analytics. Our 
            Python-based CMS solutions offer unmatched flexibility for businesses that need 
            custom workflows, multi-user access controls, and AI-powered content automation.`,

            list: [
                'Custom-built CMS platforms for enterprises',
                'SEO-friendly & content automation features',
                'User-friendly interfaces with role-based access control',
            ],
        },
    ];

    return (
        <div className="section-py bg-python-service">
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-5">
                    <div className="lg:col-span-10 gap-4 grid">
                        <h2 className="text-white">Services Offered</h2>
                        <p className="text-white mb-0 fw-600" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                            Custom Python development services for all businesses
                        </p>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-12 grid">
                        <Tabs
                            value="CustomAI"
                            orientation="vertical"
                            className="service-tabs-header"
                            animate={{ mount: false, unmount: false }}
                        >
                            <TabsHeader className="w-[26rem] service-offered-tabs">
                                {data.map(({ label, value }) => (
                                    <Tab
                                        className="service-tab-size"
                                        activeClassName="service-active-li"
                                        key={value}
                                        value={value}
                                    >
                                        {label}
                                    </Tab>
                                ))}
                            </TabsHeader>
                            <TabsBody className="bg-white transition-none">
                                {data.map(({ value, title, desc, list }) => (
                                    <TabPanel key={value} value={value} className="transition-none p-7 service-offered-listing">
                                        <h2 className="text-primary mb-4">{title}</h2>
                                        <p className="fs-md text-secondary mb-4">{desc}</p>

                                        <ul className="list-disc list-inside mb-4">
                                            {list.map((item, index) => (
                                                <li className="fs-md text-secondary mb-2" key={index}>
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </TabPanel>
                                ))}
                            </TabsBody>
                        </Tabs>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 gap-4 grid">
                        <h2 className="text-white">Your Next Big Idea Starts Here</h2>
                        <p className="text-white mb-0">
                            From concept to deployment, we turn your vision into reality with cutting-edge Python development
                            services.
                        </p>
                        <div>
                            <Link
                                href="/contact-us"
                                className="btn btn-white border-white bg-white dark:bg-black text-blue hover:bg-blue hover:text-white inline-block "
                            >
                                {'Lets Talk'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PythonServicesOffered;
